'use client';

import { createTRPCContext } from '@trpc/tanstack-react-query';
import type { Router } from '@noirproperties/functions/trpc/server';

export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<Router>();
